<div class="ncs-edit-container">
  <div class="ncs-header">

    <div class="ncs-pathway-panel">

      <div class="select-label text-info-800 d-block">
        NCS Pathway
      </div>

      <div class="hub-select-container">
        <mat-form-field>
          <mat-select [(ngModel)]="selectedPathway" placeholder="Select an NCS Pathway"
            disableOptionCentering>

            @for (pathway of ncsPathways; track pathway) {
              <mat-option [value]="pathway">
                <span>{{pathway.name}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="ncs-intervention-panel">

      <div class="select-label text-info-800 d-block">
        Intervention
      </div>

      <div class="hub-select-container">
        <mat-form-field>
          <mat-select [(ngModel)]="selectedIntervention" placeholder="Select an Intervention Type"
            disableOptionCentering>

            <div class="organizational-metrics-info"></div>

            @for (intervention of selectedPathway?.interventions; track intervention) {
              <mat-option [value]="intervention">
                <span>{{intervention.name}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

    </div>


  </div>

  <div class="ncs-body hub-custom-scrollbar">

    @if (!selectedIntervention) {
      <div class="d-block alert alert-info alert-styled-left shadow-0">
        Please select an NCS Pathway and Intervention Type.
      </div>
    } @else {
      @if (interventionForm) {
        <div [formGroup]="interventionForm">
          <table>
            <thead>
              <td style="width: 80px">ISO</td>
              <td style="width: 280px">Country Name</td>
              <td style="width: 180px">{{selectedIntervention.baseline.name}} %</td>
              @for (pool of selectedIntervention.pools; track pool) {
                <td style="width: 160px">
                  {{pool.name}} ({{pool.unit}})
                </td>
              }
              <td style="width: 200px;">Last Modified</td>
            </thead>
            <tbody>
              @for (countryForm of interventionForm.controls.countries.controls; track countryForm) {
                <tr>
                  <td class="country">
                    {{countryForm.controls.countryCode.value}}
                  </td>
                  <td class="country">
                    {{countryForm.controls.countryName.value}}
                  </td>
                  <td [ngClass]="{'invalid': countryForm.controls.baselineValue.invalid}">
                    <input [formControl]="countryForm.controls.baselineValue">
                  </td>
                  @for (pool of countryForm.controls.pools.controls; track pool) {
                    <td
                      [ngClass]="{'invalid': pool.controls.poolValue.invalid}">
                      <input [formControl]="pool.controls.poolValue">
                    </td>
                  }
                  <td>
                    {{countryForm.controls.lastModifiedByInfo.value}}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }


  </div>

  <div class="ncs-footer">
    <button class="hub-outline-button" (click)="reset()">Cancel</button>

    <button type="button" class="hub-icon-button SaveButton" [ngClass]="{ saving: isSaving }"
      [disabled]="isSaveButtonDisabled || isSaving" (click)="saveAll()">
      <b>
        <i class="icon-floppy-disk"></i>
        <i class="icon-spinner4"></i>
      </b>
      Save
    </button>
  </div>

</div>
